import React, { PropTypes } from "react";
import { Tooltip } from "react-bootstrap";
import { FormattedDate, FormattedMessage, FormattedTime, intlShape } from "react-intl";
import { change as changeFieldValue } from "redux-form";
import { Button } from "react-bootstrap/lib/InputGroup";
import { connect } from "react-redux";
import { Link } from "react-router";
import { toast } from "react-toastify";
import Toggle from "react-toggle";
import { bindActionCreators } from "redux";
import * as dataActions from "../../../utils/data/dataActions";
import { GRAPHQL_FAILURE, SIMPLE_POST_FAILURE } from "../../../utils/data/dataActionTypes";
import {
    CLIENTS_GRAPHQL,
    DEPENDENTS,
    MEMBERS_GRAPHQL,
    RESYNC,
    SYNC_NOTIFICATIONS_GRAPHQL,
    USERS_GRAPHQL,
} from "../../../utils/data/models";
import { MessageBox, OverlayRenderer } from "../../common";
import { DataTable } from "../../common/DataTable";
import { lowercaseFirstLetter, toCamelCase } from "../../common/form/DBEnumStringHelper";
import { buildGraphQLQueryParams } from "../../common/GraphQL/GraphQLQueryHelper";
import { CLASS, CLIENT, DEPENDENT_PERSON, DIVISION, MEMBER } from "./enums/syncElementTypes";
import { FAILURE, STARTED, SUCCESS } from "./enums/syncStatusTypes";
import { getErrorString } from "../../common/synchronization/SynchronizationHelper";
import SynchronizationDataFilters from "./SynchronizationDataFilters";
class SynchronizationDataTable extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            toggleFilters: ["onlyErrors", "onlyMyModifications"],
            dropdownFilters: [],
            usersOptions: [],
            clientOptions: [],
            latestRowSyncing: null,
            loading: true,
        };
        this.getData = this.getData.bind(this);
        this.clearLinkedElements = this.clearLinkedElements.bind(this);
        this.sendResync = this.sendResync.bind(this);
        this.getSyncId = this.getSyncId.bind(this);
        this.getClassName = this.getClassName.bind(this);
        this.getElementValues = this.getElementValues.bind(this);
        this.renderValue = this.renderValue.bind(this);
        this.renderLink = this.renderLink.bind(this);
        this.getErrorValues = this.getErrorValues.bind(this);
        this.elementTypeOptions = [CLIENT, MEMBER, DEPENDENT_PERSON, DIVISION, CLASS];
    }

    componentDidMount() {
        this.getClients();
        this.getUsers();
    }

    componentDidUpdate(prevProps) {
        const { clients, users } = this.props;
        let clientOptions = [];
        let usersOptions = [];
        if (prevProps.clients != this.props.clients) {
            clientOptions = clients
                ? clients.map((client) => ({
                      text: client.name,
                      value: client.clientId,
                  }))
                : [];

            this.setState({ clientOptions });
        }

        if (prevProps.users != this.props.users) {
            usersOptions = users
                ? users.map((user) => ({
                      text: `${user.firstName} ${user.lastName}`,
                      value: user.userId,
                  }))
                : [];

            this.setState({ usersOptions });
        }
    }

    componentWillUnmount() {
        if (this.props.dataActions && this.props.dataActions.clearDataList) {
            this.props.dataActions.clearDataList(SYNC_NOTIFICATIONS_GRAPHQL);
        }
    }
    clearLinkedElements() {
        this.props.dataActions.clearDataList(MEMBERS_GRAPHQL);
        this.props.dataActions.clearDataList(DEPENDENTS);
    }

    sendResync(item) {
        const { dataActions, offset, limit, q, sortBy } = this.props;
        const msg_root = "synchronizations.datatable.resyncMessages.";
        this.setState({ latestRowSyncing: this.getSyncId(item) });
        return dataActions
            .simplePost({ model: RESYNC, data: item })
            .then((data) => {
                let msg_id = msg_root + "resyncSent";
                let toast_type = toast.TYPE.SUCCESS;
                if (data) {
                    if (data.type == SIMPLE_POST_FAILURE) {
                        this.setState({ latestSyncedRow: null });
                        msg_id = msg_root + "resyncError";
                        toast_type = toast.TYPE.ERROR;
                    }
                } else {
                    this.setState({ latestSyncedRow: null });
                    msg_id = msg_root + "resyncUnknownError";
                    toast_type = toast.TYPE.ERROR;
                }
                toast(<FormattedMessage id={msg_id} />, {
                    type: toast_type,
                    autoClose: toast_type == toast.TYPE.ERROR ? false : 5000,
                });
                this.getData(offset, limit, q, sortBy);
            })
            .catch(() => {
                this.setState({ latestSyncedRow: null });
                toast(<FormattedMessage id={msg_root + "resyncUnknownError"} />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
                this.getData(offset, limit, q, sortBy);
            });
    }

    getSyncId(sync) {
        const elemType = sync.elementType;
        switch (elemType) {
            case CLIENT.value:
                return sync.clientSyncId;
            case DIVISION.value:
                return sync.divisionSyncId;
            case CLASS.value:
                return sync.classSyncId;
            case MEMBER.value:
                return sync.memberCoverageSyncId;
            case DEPENDENT_PERSON.value:
                return sync.dependentPersonCoverageSyncId;
            default:
                return null;
        }
    }

    getClassName(status) {
        let className = "alert-warning";
        switch (status) {
            case SUCCESS:
                className = "alert-success";
                break;
            case FAILURE:
                className = "alert-danger";
                break;
            case STARTED:
                className = "alert-warning";
                break;
            default:
                className = "alert-warning";
        }
        return className;
    }

    renderLink(to, title, name, extraInfo) {
        return (
            <div>
                <Link to={to} title={title} target="_blank">
                    <span className="sync-link">{name || <FormattedMessage id="common.nd" />}</span>
                </Link>
                {extraInfo && (
                    <span style={{ float: "left" }} className="additional-info">
                        {" "}
                        {extraInfo}
                    </span>
                )}
            </div>
        );
    }

    renderValue(condition, element) {
        return condition ? element : <FormattedMessage id="common.nd" />;
    }

    getElementValues(item) {
        const clientId = item && item.client && item.client.clientId;
        if (clientId == undefined || !clientId) {
            return <FormattedMessage id="common.nd" />;
        }

        switch (item.elementType) {
            case DEPENDENT_PERSON.value:
                return (
                    <div>
                        {this.renderValue(
                            item.dependentPerson,
                            this.renderLink(
                                `/dashboard/clients/${clientId}/members/${item.member.memberId}/dependents/${item.dependentPerson.dependentPersonId}`,
                                `${item.dependentPerson.firstName} ${item.dependentPerson.lastName}`,
                                `${item.dependentPerson.firstName} ${item.dependentPerson.lastName}`
                            )
                        )}
                    </div>
                );

            case MEMBER.value:
                return (
                    <div>
                        {this.renderValue(
                            item.member,
                            this.renderLink(
                                `/dashboard/clients/${clientId}/members/${item.member.memberId}/profile`,
                                `${item.member.firstName} ${item.member.lastName}`,
                                `${item.member.firstName} ${item.member.lastName}`,
                                item.member.memberIdentifier || <FormattedMessage id="common.nd" />
                            )
                        )}
                    </div>
                );

            case CLASS.value:
                return (
                    <div>
                        {this.renderValue(
                            item.class_,
                            this.renderLink(
                                `dashboard/clients/${clientId}/classes`,
                                item.client.name,
                                item.class_.name,
                                item.class_.externalClassNumber || <FormattedMessage id="common.nd" />
                            )
                        )}
                    </div>
                );

            case DIVISION.value:
                return (
                    <div>
                        {this.renderValue(
                            item.division,
                            this.renderLink(
                                `dashboard/clients/${clientId}/divisions`,
                                item.client.name,
                                item.division.name,
                                item.division.externalDivisionNumber || <FormattedMessage id="common.nd" />
                            )
                        )}
                    </div>
                );

            case CLIENT.value:
                return (
                    <div>
                        {this.renderValue(
                            item.client,
                            this.renderLink(
                                `dashboard/clients/${clientId}/members`,
                                item.client.name,
                                item.client.name,
                                item.client.clientNumber || <FormattedMessage id="common.nd" />
                            )
                        )}
                    </div>
                );

            default:
                return <FormattedMessage id="common.nd" />;
        }
    }

    getErrorValues(item) {
        const clientId = item && item.client && item.client.clientId;
        const validElementTypes = [DEPENDENT_PERSON.value, MEMBER.value, CLASS.value, DIVISION.value, CLIENT.value];
        if (!clientId || !validElementTypes.includes(item.elementType)) {
            return undefined;
        }
        let errors = "";
        if (item.errors && item.errors.length > 0) {
            errors = item.errors.map((error) => getErrorString([error], this.context.intl));
        }
        return errors;
    }

    getCols() {
        return [
            {
                name: <FormattedMessage id="synchronizations.datatable.columns.status" />,
                display: (item) => {
                    let displayResyncButton = !!item.isEligibleForResync;
                    if (this.getSyncId(item) == this.state.latestRowSyncing) {
                        displayResyncButton = false;
                    }
                    return (
                        <div>
                            {displayResyncButton ? (
                                <OverlayRenderer
                                    placement="top"
                                    overlay={
                                        <Tooltip id={item.elementType + "-" + this.getSyncId(item)}>
                                            <FormattedMessage id="synchronizations.datatable.resyncButtonMsg" />
                                        </Tooltip>
                                    }
                                >
                                <span>
                                    <Button
                                        className="btn resync-button synchronization-resync-btn"
                                        bsStyle={"primary"}
                                        bsSize={"xsmall"}
                                        onClick={() => this.sendResync(item)}
                                        disabled={false}
                                    >
                                        <MessageBox className={`client-synchronization-alert ${this.getClassName(item.status)} synchronization-alert`}>
                                            <span style={{textTransform: 'capitalize'}} className={this.getClassName(item.status)}>{<FormattedMessage id={`clients.client.processSync.datatable.statusTypes.${item.status.toLowerCase()}`}/>}</span>
                                        </MessageBox>
                                    </Button>
                                    </span>
                                </OverlayRenderer>
                            ) : (
                                <MessageBox className={`client-synchronization-alert ${this.getClassName(item.status)} synchronization-alert`}>
                                    <span style={{textTransform: 'capitalize'}} className={this.getClassName(item.status)}>{<FormattedMessage id={`clients.client.processSync.datatable.statusTypes.${item.status.toLowerCase()}`}/>}</span>
                                </MessageBox>
                            )}
                        </div>
                    );
                },
                widthPct: 9,
            },
            {
                name: <FormattedMessage id="synchronizations.datatable.columns.date" />,
                key: "syncDate",
                display: (item) => {
                    const syncDate = new Date(item.syncDate + "Z");
                    return (
                        <span className="highlighted-datetime">
                            <span className="date">
                                <FormattedDate value={syncDate} year="numeric" month="long" day="2-digit" />
                            </span>
                            <span className="time">
                                <FormattedTime value={syncDate} hour="numeric" minute="numeric" />
                            </span>
                        </span>
                    );
                },
                widthPct: 8,
                reverseSortOrder: true,
                displayReverseSortOrder: true,
            },
            {
                name: <FormattedMessage id="synchronizations.datatable.columns.user" />,
                display: (item) => {
                    return item.user ? (
                        <div>
                            {item.user.firstName} {item.user.lastName}
                        </div>
                    ) : (
                        <FormattedMessage id="common.nd" />
                    );
                },
                widthPct: 9,
            },
            {
                name: <FormattedMessage id="synchronizations.datatable.columns.event" />,
                display: (item) => {
                    const eventContent = item.eventName ? (
                        <FormattedMessage
                            id={`synchronizations.datatable.eventName.${lowercaseFirstLetter(item.eventName)}`}
                        />
                    ) : (
                        <FormattedMessage id="common.nd" />
                    );
                    return <div>{eventContent}</div>;
                },
                widthPct: 10,
            },
            {
                name: <FormattedMessage id="synchronizations.datatable.columns.client" />,
                display: (item) => {
                    return item.client ? (
                        <div>
                            <Link
                                to={`dashboard/clients/${item.client.clientId}/members`}
                                title={`${item.client.name}`}
                                target="_blank"
                            >
                                <span className="sync-link">
                                    {item.client.name ? item.client.name : <FormattedMessage id="common.nd" />}
                                </span>
                            </Link>
                        </div>
                    ) : (
                        <div>
                            <FormattedMessage id="common.nd" />
                        </div>
                    );
                },
                widthPct: 15,
            },
            {
                name: <FormattedMessage id="synchronizations.datatable.columns.elementType" />,
                display: (item) => {
                    const elementTypeContent = item.elementType ? (
                        <FormattedMessage
                            id={`synchronizations.datatable.elementType.${toCamelCase(item.elementType)}`}
                        />
                    ) : (
                        <FormattedMessage id="common.nd" />
                    );
                    return <div>{elementTypeContent}</div>;
                },
                widthPct: 10,
            },
            {
                name: <FormattedMessage id="synchronizations.datatable.columns.element" />,
                display: (item) => {
                    return this.getElementValues(item);
                },
                widthPct: 15,
            },
            {
                name: <FormattedMessage id="synchronizations.datatable.columns.details" />,
                display: (item) => {
                    if (item.status == FAILURE) {
                        const notificationDetail = this.getErrorValues(item);
                        let tooltip = undefined;
                        if (notificationDetail) {
                            const errorMessages = notificationDetail.map((error, index) => {
                                error = error.trim();
                                return <li key={index}>{error.endsWith(".") ? error : error + "."}</li>;
                            });
                            tooltip = (
                                <Tooltip id="tooltip">
                                    <div className="word-break">{<ul>{errorMessages}</ul>}</div>
                                </Tooltip>
                            );
                            return (
                                <OverlayRenderer
                                    placement="left"
                                    overlay={tooltip}
                                    overlayedClassName="tooltipped-cell"
                                    forceOverlay={/\r|\n/.test(notificationDetail)}
                                >
                                    <span
                                        style={{
                                            maxWidth: "100%",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            position: "absolute",
                                            display: "block",
                                            alignSelf: "anchor-center",
                                        }}
                                    >
                                        {notificationDetail}
                                    </span>
                                </OverlayRenderer>
                            );
                        }
                    }
                },
                widthPct: 23,
            },
        ];
    }

    handleToggleChange = (event, filterName) => {
        const { toggleFilters } = this.state;
        const newtoggleFilters = toggleFilters.includes(filterName)
            ? toggleFilters.filter((t) => t !== filterName)
            : [...toggleFilters, filterName];
        this.setState({ toggleFilters: newtoggleFilters }, () => {
            this.getData(0, this.props.limit, this.props.q, this.props.sortBy);
        });
    };

    handleDropdownChange = (filters) => {
        const newDropdownFilters = [];
        if (filters) {
            if (filters.userId && filters.userId.trim()) newDropdownFilters.push(`userId==${filters.userId}`);
            if (filters.clientId && filters.clientId.trim()) newDropdownFilters.push(`clientId==${filters.clientId}`);
            if (filters.elementType && filters.elementType.trim())
                newDropdownFilters.push(`elementType==${filters.elementType}`);
        }
        this.setState({ dropdownFilters: newDropdownFilters }, () => {
            this.getData(0, this.props.limit, this.props.q, this.props.sortBy);
        });
    };

    getFilterButtons() {
        return (
            <div className="toggle-buttons-container">
                <label className="toggle-color">
                    <Toggle
                        disabled={false}
                        icons={{ checked: null, unchecked: null }}
                        defaultChecked={true}
                        onChange={(event) => this.handleToggleChange(event, "onlyMyModifications")}
                    />
                    <span>
                        <FormattedMessage id="clients.client.processSync.notificationsBoard.filters.onlyMyModifications" />
                    </span>
                </label>

                <label className="toggle-color">
                    <Toggle
                        disabled={false}
                        icons={{ checked: null, unchecked: null }}
                        defaultChecked={true}
                        onChange={(event) => this.handleToggleChange(event, "onlyErrors")}
                    />
                    <span>
                        <FormattedMessage id="clients.client.processSync.notificationsBoard.filters.onlyErrors" />
                    </span>
                </label>
            </div>
        );
    }

    getListFilters() {
        const { clientOptions, usersOptions } = this.state;
        const isModificationOnly =
            this.state.toggleFilters && this.state.toggleFilters.length > 0
                ? this.state.toggleFilters.includes("onlyMyModifications")
                : false;
        return (
            <SynchronizationDataFilters
                userOptions={usersOptions}
                clientOptions={clientOptions}
                elementTypeOptions={this.elementTypeOptions}
                onFilterChange={this.handleDropdownChange}
                isModificationOnly={isModificationOnly}
            />
        );
    }

    getClients() {
        let filters = [];
        const sort = [CLIENTS_GRAPHQL.defaultSort];
        const columns = `
	                clientId
	                isArchived
	                name
	            `;
        const clientGraphQLQuery = buildGraphQLQueryParams("clients", filters, sort, 0, 0, columns, "getClients", "");
        this.props.dataActions.getGraphQL(CLIENTS_GRAPHQL, { query: clientGraphQLQuery }, sort);
    }

    getUsers() {
        let filters = ["allUsers"];
        const sort = [USERS_GRAPHQL.defaultSort];
        const columns = `
                username
                languageCode
                roleId
                isArchived
                lastModifiedPasswordDate
	            userId
	            firstName
	            lastName
	        `;
        const userGraphQLQuery = buildGraphQLQueryParams("users", filters, sort, 0, 0, columns, "getUsers", "");
        this.props.dataActions.getGraphQL(USERS_GRAPHQL, { query: userGraphQLQuery }, sort);
    }

    getData(offset, limit, q, sortBy) {
        
        if(!this.state.loading) {
            this.setState({ loading: true});
        }
        const colsStr = `
            dependentPersonCoverageSyncId
            dependentPersonCoverageId
            memberCoverageSyncId
            memberCoverageId
            classSyncId
            classId
            divisionSyncId
            divisionId
            clientSyncId
            clientId
            syncDate
            errors
            client {
                name
                clientId
                clientNumber
            }
            division {
                name
                divisionId
                externalDivisionNumber
            }
            status
            provider
            elementType
            member {
                memberId
                firstName
                lastName
                memberIdentifier
            }
            user {
                userId
                firstName
                lastName
            }
            dependentPerson {
                dependentPersonId
                firstName
                lastName
            }
            class_ {
                classId
                name
                externalClassNumber
            }
            eventName
            isEligibleForResync
            `;
        let allFilters = [
            ...this.props.filters,
            `onlyErrors==${this.state.toggleFilters.includes("onlyErrors")}`,
            `onlyMyModifications==${this.state.toggleFilters.includes("onlyMyModifications")}`,
            ...this.state.dropdownFilters,
        ];
        const graphQLQuery = buildGraphQLQueryParams(
            "syncedData",
            allFilters,
            sortBy,
            offset,
            limit,
            colsStr,
            "syncedData",
            q
        );
        return this.props.dataActions
            .getGraphQL(SYNC_NOTIFICATIONS_GRAPHQL, { query: graphQLQuery }, sortBy)
            .then((response) => {
                if (!response || response.type == GRAPHQL_FAILURE) {
                    toast(<FormattedMessage id={"genericDataFetchError"} />, {
                        type: toast.TYPE.ERROR,
                        autoClose: false,
                    });
                } else {
                    this.setState({ loading: false });
                }
            });
    }

    render() {
        return (
            <div className="sub-content" style={{ marginLeft: "40px" }}>
                <div className="synchronizations-datatable-header">
                    {this.getFilterButtons()}
                    {this.getListFilters()}
                </div>
                <div className="synchronizations-datatable">
                        <DataTable
                            ref="dataTable"
                            getData={this.getData}
                            cols={this.getCols()}
                            q={this.props.q}
                            filters={this.props.filters}
                            offset={this.props.offset}
                            data={this.props.items}
                            rowsPerPage={this.props.limit}
                            totalRows={this.props.total}
                            showOverflow={true}
                            showTitle={true}
                            sortBy={this.props.sortBy}
                            hideSearch={true}
                            refreshFunction={this.getData}
                            showLoadingMessage={this.state.loading}
                        />
                </div>
            </div>
        );
    }
}

SynchronizationDataTable.contextTypes = {
    intl: intlShape,
};

SynchronizationDataTable.propTypes = {
    dataActions: PropTypes.object,
    filters: PropTypes.array,
    items: PropTypes.array,
    q: PropTypes.string,
    languages: PropTypes.array,
    limit: PropTypes.number,
    offset: PropTypes.number,
    sortBy: PropTypes.array,
    total: PropTypes.number,
    clients: PropTypes.array,
    users: PropTypes.array,
    changeFieldValue: PropTypes.func,
};

function mapStateToProps(state) {
    const data = state.data.syncedData || {};
    const clients = state.data.clients || {};
    const users = state.data.users || {};
    return {
        limit: 20,
        offset: data.offset || 0,
        sortBy: data.sortBy || [SYNC_NOTIFICATIONS_GRAPHQL.defaultSort],
        q: data.q || "",
        filters: data.filters || [SYNC_NOTIFICATIONS_GRAPHQL.getEligibilityFilter],
        total: data.totalCount || 0,
        items: data.items || [],
        clients: clients.items || [],
        users: users.items || [],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SynchronizationDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/synchronization/SynchronizationDataTable.js